import { httpGet, httpPost } from "../remoteDataProvider"
import { AssociationId } from "../../types"
import { BulkDisciplineActionSchema } from "../../types/disciplineTypes"

const getBulkDisciplineActions = async (
  association: AssociationId,
  token: string,
): Promise<BulkDisciplineActionSchema[]> => {
  try {
    const { data } = await httpGet("people_flow_core", `/discipline/bulk-actions/${association}`, token)
    return data.bulkActionTasks || []
  } catch (error) {
    console.error("getBulkDisciplineActions error:", error)
    throw error
  }
}

const putBulkDisciplineActions = async (
  association: AssociationId,
  bulkActionTasks: BulkDisciplineActionSchema[],
  token: string,
) => {
  try {
    const body = {
      association,
      bulkActionTasks,
    }
    const { data } = await httpPost("people_flow_core", `/discipline/bulk-actions/${association}`, body, token)
    console.log("putBulkDisciplineActions data:", data)
  } catch (error) {
    console.error("putBulkDisciplineActions error:", error)
    throw error
  }
}

export { getBulkDisciplineActions, putBulkDisciplineActions }
